import { createFileRoute } from '@tanstack/react-router'
import { PhysicalInstallSteps } from '@/components/installFlowV2/physical-install-steps'
import { z } from 'zod'

export const Route = createFileRoute('/installFlow/physical-install-steps')({
  component: PhysicalInstallSteps,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
    step: z.coerce.number().int().min(0).catch(0),
  }),
})


